<template>
  <main>
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('door.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('door.doorsSummary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="default-section-actions text-align-end">
              <add-dialog-button />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>

import WarehouseList from '@/components/WarehouseList/WarehouseList';
import SearchFilter from './SearchFilters';
import SearchSummary from './SearchSummary';
import AddDialogButton from './components/AddDialog';

export default {
  name: 'door',
  components: {
    AddDialogButton,
    SearchFilter,
    SearchSummary,
    WarehouseList
  },
  data() {
    return {
      actionMountChained: ['door/setDefaultFilters'],
      actionSelectChained: ['door/search']
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
